import { Stack, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useMemo, useState } from 'react'
import ViewContact from '../ViewContact'
import * as React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const Titres = ['Mme', 'Mr', 'Mlle', 'Dr', 'ST']

function ListOperations({ fetchOperations, operations, setSelectedRows }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)

  // LAP-733 (GE022) — DataGrid columns rebuilt per render so `headerName`
  // values pick up the active locale. Field keys stay untranslated (they
  // map to data fields and must remain stable across languages).
  const columns = useMemo(() => [
    { field: 'id', headerName: t('contacts.headerID'), width: 50 },
    {
      field: 'Titre',
      headerName: t('contacts.headerTitre'),
      width: 70,
      editable: false,
      valueGetter: (params) => params.row.Titres?.Titre,
    },
    {
      field: 'Nom',
      headerName: t('contacts.headerNom'),
      width: 130,
      editable: false,
    },
    {
      field: 'Prenom',
      headerName: t('contacts.headerPrenom'),
      width: 100,
      editable: false,
    },
    {
      field: 'surnom',
      headerName: t('contacts.headerSurnom'),
      width: 100,
      editable: false,
    },
    {
      field: 'Job',
      headerName: t('contacts.headerJob'),
      width: 150,
      editable: false,
      valueGetter: (params) => params.row.Job && params.row.Job.replace('undefined', ''),
    },
    {
      field: 'Societe',
      headerName: t('contacts.headerSociete'),
      width: 100,
      editable: false,
      valueGetter: (params) => params.row.Societe && params.row.Societe.replace('undefined', ''),
    },
    {
      field: 'Pays',
      headerName: t('contacts.headerPays'),
      width: 130,
      editable: false,
      valueGetter: (params) =>
        params.row.Pays !== 'undefined' &&
        params.row.Pays.length !== 0 &&
        params.row.Pays[0]?.CountryCode !== 'undefined'
          ? `${params.row.Pays[0]?.CountryCode} / ${params.row.Pays[0]?.Nationality}`
          : '',
    },
    {
      field: 'Portable',
      headerName: t('contacts.headerPortable'),
      width: 130,
      editable: false,
      valueGetter: (params) => params.row.Portable && params.row.Portable.replace('undefined', ''),
    },
    {
      field: 'Ville',
      headerName: t('contacts.headerVille'),
      width: 150,
      editable: false,
    },
    {
      field: 'Categorie',
      headerName: t('contacts.headerCategorie'),
      width: 140,
      valueGetter: (params) =>
        params.row.Category !== 'undefined' &&
        params.row.Category.length !== 0 &&
        params.row.Category[0]?.Categorie !== 'undefined'
          ? `${params.row.Category[0]?.Categorie}`
          : '',
    },
    {
      field: 'SousCategorie',
      headerName: t('contacts.headerSousCategorie'),
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 140,
      valueGetter: (params) =>
        params.row.Category !== 'undefined' &&
        params.row.Category.length !== 0 &&
        params.row.Category[0]?.SousCategorie !== 'undefined'
          ? `${params.row.Category[0]?.SousCategorie}`
          : '',
    },
    {
      field: 'Groupes',
      headerName: t('contacts.headerGroupes'),
      width: 130,
      valueGetter: (params) =>
        params.row?.Groupes[0]?.Name !== 'undefined' ? params.row?.Groupes[0]?.Name : '',
    },
    {
      field: 'WebPage',
      headerName: t('contacts.headerWebPage'),

      width: 150,
      editable: false,
    },
  ], [t])

  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  let navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }

  const [id, setID] = React.useState('')
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    if (searchParams.has('cid') && searchParams.get('cid')) {
      if (parseInt(searchParams.get('cid'))) {
        setOpen(true)
        setID(searchParams.get('cid'))
      }
    }
  }, [])
  React.useEffect(() => {
    if (id) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [id])

  return (
    <div
      style={{
        height: '75vh',
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
        mb: 10,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {/* LAP-733 (GE022) */}
        {t('contacts.pageTitle')} ({operations.count})
      </Typography>
      <DataGrid
        sx={{
          '.MuiTablePagination-toolbar': {
            alignItems: 'baseline',
          },
          '.MuiDataGrid-footerContainer': { background: 'white' },
        }}
        rows={operations.results ? operations.results : []}
        onRowClick={(params, event) => {
          setID(params.id)
          setOpen(true)
          navigate('?cid=' + params.id)
        }}
        columns={columns}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        disableSelectionOnClick
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              {/* LAP-733 (GE022) */}
              {t('contacts.noDataFound')}
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              {/* LAP-733 (GE022) */}
              {t('contacts.noDataFound')}
            </Stack>
          ),
        }}
        checkboxSelection
      />
      {open === true && <ViewContact open={open} id={id} setModalOpen={setID} />}
    </div>
  )
}
export default ListOperations
